export const environment = {
  development: false,
  staging: false,
  production: true,
  basePath: 'https://connect.unity4.com',
  apiPath: 'https://connect.unity4.com/api',
  authServer: 'https://login.unity4.com',
  authClientId: 'teleworker-ng',
  authScope: [
    'teleworker-api',
    'presence-signalr',
    'dialler-signalr',
    'chat-signalr',
  ],
  authRedirect: ['/work/scripttester'],
  logLevel: 2, //Info,
  chatHub: 'https://chat.unity4.com/hub',
  diallerHub: 'https://dialler.unity4.com/hub',
  presenceHub: 'https://presence-sig.unity4.com/hub',
  notifyHub: '',
};
